import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const reveal = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

const PILLARS = [
  {
    to: "/films",
    label: "Films",
    desc: "Cinematic brand films, commercial spots and long-form storytelling.",
    img: "https://images.unsplash.com/photo-1623346483743-b968a27ed34c?w=1600&q=85",
  },
  {
    to: "/work/photography",
    label: "Photography",
    desc: "Editorial photography, product stills and campaign imagery.",
    img: "https://images.pexels.com/photos/36237587/pexels-photo-36237587.jpeg?w=1600",
  },
  {
    to: "/work/campaigns",
    label: "Campaigns",
    desc: "Integrated creative campaigns across film, print, digital and social.",
    img: "https://images.unsplash.com/photo-1578245600656-e8fe67a2b5f7?w=1600&q=85",
  },
];

export default function Work() {
  return (
    <main data-testid="work-page" className="bg-black pt-32 pb-8">
      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 mb-20">
        <motion.p {...reveal} className="overline mb-6">Selected Work</motion.p>
        <motion.h1 {...reveal} className="font-display text-6xl md:text-8xl text-white leading-[0.95]">
          Work <span className="italic text-[var(--gb-gold)]">/</span> Studio
        </motion.h1>
        <motion.p {...reveal} className="text-white/65 text-base md:text-lg max-w-2xl mt-10 leading-relaxed">
          Commercial creative for luxury brands, cultural institutions and independent
          makers. Films, photography and campaigns built with editorial rigour.
        </motion.p>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 md:grid-cols-3 gap-1">
        {PILLARS.map((p) => (
          <motion.div {...reveal} key={p.to} className="group">
            <Link to={p.to} data-testid={`work-pillar-${p.label.toLowerCase()}`} className="block relative aspect-[3/4] overflow-hidden">
              <img
                src={p.img}
                alt={p.label}
                className="absolute inset-0 w-full h-full object-cover opacity-75 group-hover:opacity-90 group-hover:scale-[1.02] transition-all duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute inset-0 p-8 flex flex-col justify-between">
                <div className="flex items-start justify-between">
                  <p className="kbd text-[var(--gb-gold)]">0{PILLARS.indexOf(p) + 1}</p>
                  <ArrowRight size={16} className="text-[var(--gb-gold)] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>
                <div>
                  <h2 className="font-display text-4xl md:text-5xl text-white leading-tight group-hover:text-[var(--gb-gold)] transition-colors duration-500">
                    {p.label}
                  </h2>
                  <p className="text-white/60 text-sm mt-3 max-w-xs leading-relaxed">{p.desc}</p>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </section>
    </main>
  );
}
